import { render, staticRenderFns } from "./TabPenibiliteConfig.vue?vue&type=template&id=986956c6"
import script from "./TabPenibiliteConfig.vue?vue&type=script&lang=js"
export * from "./TabPenibiliteConfig.vue?vue&type=script&lang=js"
import style0 from "./TabPenibiliteConfig.vue?vue&type=style&index=0&id=986956c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports